import React from 'react';
import { Card, Button, Alert } from '@/components/ui';
import type { ConstructionContract } from '../types/construction-contracts.types';

interface SidebarInfoProps {
  item: ConstructionContract;
}

export function SidebarInfo({ item }: SidebarInfoProps) {
  return (
    <div className="space-y-6">
      <Card className="p-6 bg-slate-900 text-white overflow-hidden relative">
        <div className="absolute top-[-20px] right-[-20px] opacity-10">
            <i className="ri-calendar-event-line text-8xl" />
        </div>
        <h4 className="font-bold mb-6 flex items-center gap-2 relative z-10">
          <i className="ri-history-line text-os-primary" />
          Lịch trình thực hiện
        </h4>
        <div className="space-y-6 relative z-10">
          <div className="relative pl-6 border-l border-slate-700 pb-2">
            <div className="absolute left-[-5px] top-0 w-2.5 h-2.5 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]" />
            <p className="text-[10px] text-slate-400 font-bold  tracking-widest">Bắt đầu thi công</p>
            <p className="text-sm font-bold">{new Date(item.start_date).toLocaleDateString('vi-VN')}</p>
          </div>
          <div className="relative pl-6 border-l border-slate-700">
            <div className="absolute left-[-5px] top-0 w-2.5 h-2.5 rounded-full bg-slate-600" />
            <p className="text-[10px] text-slate-400 font-bold  tracking-widest">Ngày hoàn thành dự kiến</p>
            <p className="text-sm font-bold">{item.end_date ? new Date(item.end_date).toLocaleDateString('vi-VN') : '---'}</p>
          </div>
          <div className="pt-4 border-t border-slate-800">
            <Alert variant="info" className="bg-blue-900/30 border-blue-800 text-blue-200">
              Dự án còn 45 ngày thi công theo kế hoạch hợp đồng.
            </Alert>
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <h4 className="font-bold text-slate-900 mb-4 flex items-center gap-2">
          <i className="ri-refund-2-line text-slate-400" />
          Điều khoản Thanh toán
        </h4>
        <p className="text-xs text-slate-600 italic bg-slate-50 p-4 rounded-2xl border border-slate-100 leading-relaxed">
          {item.payment_terms || 'Chưa có thông tin điều khoản thanh toán chi tiết.'}
        </p>
        <Button variant="ghost" size="sm" className="w-full mt-4 text-os-primary text-xs font-bold">
          Xem bảng mốc thanh toán
        </Button>
      </Card>
    </div>
  );
}
